export class SearchConfig {
      type?: string;
      ost_type: number; //0 = 'attrattore' - 1 = 'sentieri'
      fulltext?: string;
      fromdate?: any;
      todate?: any;
      locale?: string;
      filters?: string;
      last_modified_since?:number;
      tematica?: string;
      tipologia?: string;
      rete?: string;
      fruizione?: string;
      stato_fondo?: string;
      tipo_fondo?: string;
      difficolta?: string;
      presenza_segnaletica?: string;
      accessibilita?: string;
      regioni?: string;
      duratastart?: number;
      durataend?: number;
      formatTime?: string;
      dislivellostart?: number;
      dislivelloend?: number;
      distanzastart?: number;
      distanzaend?: number;
      altezzastart?: number;
      altezzaend?: number;
      altezzaminstart?: number;
      altezzaminend?: number;
      altezzamaxstart?: number;
      altezzamaxend?: number;
      percorrenzastart?: string;
      percorrenzaend?: string;
      bbox?: string;
      xmin?: number;
      xmax?: number;
      ymin?: number;
      ymax?: number;
      page?: number;
      count?: number;
      orderby?: string;
      order?: string;
      pageNumber?: number;
      pageSize?: number;
      mezzo?:string;

    constructor() { 
        this.tematica = "null",
        this.tipologia = "null",
        this.rete = "null",
        this.fruizione = "null",
        this.stato_fondo = "null",
        this.tipo_fondo = "null",
        this.difficolta = "null",
        this.presenza_segnaletica = "null",
        this.accessibilita = "null",
        this.regioni = "null"
        this.formatTime = 'h';
        this.ost_type = 0;
        this.duratastart = 0;
        this.durataend = 24;
        this.dislivellostart = 0;
        this.dislivelloend = 9999;
        this.distanzastart = 0;
        this.distanzaend = 9999;
        this.altezzastart = 0;
        this.altezzaend = 9999;
        this.altezzaminstart = 0;
        this.altezzaminend = 9999;
        this.altezzamaxstart = 0;
        this.altezzamaxend = 9999;
        this.percorrenzastart = "00:00:00"
        this.percorrenzaend = "99:99:99";
        this.mezzo = "null";
    }
  }
  